"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Module = window.Module;
var GameView = (function () {
    function GameView(gameControl, render, level) {
        this.isReadingMessages = false;
        this.gameControl = gameControl;
        this.level = level;
        this.render = render;
        this.gameControl.setViewSize(this.render.width, this.render.height);
        this.render.setGameControl(this.gameControl);
        this.render.setOnTouchListener(this);
        this.render.setWheelListener(this);
    }
    GameView.prototype.isCanUndo = function () {
        var res = this.gameControl.isCanUndo();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.isCanRedo = function () {
        var res = this.gameControl.isCanRedo();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.solved = function () {
        var res = this.gameControl.getSolvedStatus();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.elementaryMovesCount = function () {
        var res = this.gameControl.getElementaryMovesCount();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.lineMovesCount = function () {
        var res = this.gameControl.getLineMovesCount();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.hintFigureType = function () {
        var res = this.gameControl.getHintFigureType();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.hintCoordinate = function (num) {
        var coord = this.gameControl.getHintCoordinate(num);
        this.readGameControlMessages();
        return coord;
    };
    GameView.prototype.undo = function () {
        this.gameControl.undo();
        this.readGameControlMessages();
    };
    GameView.prototype.redo = function () {
        this.gameControl.redo();
        this.readGameControlMessages();
    };
    GameView.prototype.restart = function () {
        this.gameControl.restart();
        this.readGameControlMessages();
    };
    GameView.prototype.detailSolutionWithLMovesWithEMoves = function (content, lMoves, eMoves) {
        var moves = new Module.SolutionMoves();
        var resStr = this.gameControl.detailSolution(content, moves);
        this.readGameControlMessages();
        return resStr;
    };
    GameView.prototype.isSolutionEqualToSolution = function (content1, content2) {
        return Module.GameControl.isSolutionEqualToSolution(content1, content2);
    };
    GameView.prototype.encodeTaskWithUndoList = function (withUndo) {
        var resStr = this.gameControl.encodeTaskWithUndoListCnt(withUndo);
        this.readGameControlMessages();
        return resStr;
    };
    GameView.prototype.decodeTaskWithFormatWithUndoList = function (content, format, withUndo) {
        this.gameControl.decodeTask(content, format, withUndo);
        this.readGameControlMessages();
    };
    GameView.prototype.recreateFieldWithGrid = function (gridType) {
        this.gameControl.recreateField(gridType);
        this.readGameControlMessages();
    };
    GameView.prototype.showSolution = function () {
        this.gameControl.showSolution();
        this.readGameControlMessages();
    };
    GameView.prototype.moveField = function (coord, moveState) {
        this.gameControl.moveField(coord, moveState);
        this.readGameControlMessages();
    };
    GameView.prototype.scaleField = function (scale, coords, moveState) {
        this.gameControl.scaleField(scale, coords, moveState);
        this.readGameControlMessages();
    };
    GameView.prototype.rotateField = function (rotation, moveState) {
        this.gameControl.rotateField(rotation, moveState);
        this.readGameControlMessages();
    };
    GameView.prototype.tapped = function (coordinate) {
        this.gameControl.tapped(coordinate);
        this.readGameControlMessages();
    };
    GameView.prototype.move = function (coord, moveState) {
        this.gameControl.move(coord, moveState);
        this.readGameControlMessages();
    };
    GameView.prototype.hover = function (coord) {
        this.gameControl.hover(coord);
        this.readGameControlMessages();
    };
    GameView.prototype.toolType = function () {
        var resStr = this.gameControl.getToolType();
        this.readGameControlMessages();
        return resStr;
    };
    GameView.prototype.setToolType = function (toolType) {
        this.gameControl.setToolType(toolType);
        this.readGameControlMessages();
    };
    GameView.prototype.resetToolType = function () {
        this.gameControl.resetTool();
        this.readGameControlMessages();
    };
    GameView.prototype.gameMode = function () {
        var res = this.gameControl.getGameMode();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.setGameMode = function (gameMode) {
        this.gameControl.setGameMode(gameMode);
        this.readGameControlMessages();
    };
    GameView.prototype.startTutorial = function () {
        this.gameControl.startTutorial();
        this.readGameControlMessages();
    };
    GameView.prototype.updateHintIfNeeded = function () {
        var res = this.gameControl.updateHintIfNeeded();
        this.readGameControlMessages();
        return res;
    };
    GameView.prototype.readGameControlMessages = function () {
        if (this.isReadingMessages) {
            return;
        }
        this.isReadingMessages = true;
        var messageInfo = new Module.MessageInfo();
        while (this.gameControl.popGameMessage(messageInfo)) {
            switch (messageInfo.message) {
                case Module.GameMessage.GameMessageDidChangeMoveCount:
                    this.level.notifyChangeMoveCount();
                    break;
                case Module.GameMessage.GameMessageDidChangeUndoStatus:
                    this.level.notifyChangeUndoStatus();
                    break;
                case Module.GameMessage.GameMessageDidChangeRedoStatus:
                    this.level.notifyChangeRedoStatus();
                    break;
                case Module.GameMessage.GameMessageDidChangeTaskStatus:
                    this.level.notifyChangeTaskStatus();
                    break;
                case Module.GameMessage.GameMessageDidChangeMode:
                    this.level.notifyChangeGameMode();
                    break;
                case Module.GameMessage.GameMessageDidMovePoint:
                    this.level.notifyMovePoint();
                    break;
                case Module.GameMessage.GameMessageDidTouchScreen:
                    this.level.notifyTouchScreen(messageInfo.value != 0);
                    break;
                case Module.GameMessage.GameMessageDidChangeCursor:
                    this.level.notifyChangeCursor(messageInfo.value != 0);
                    break;
                case Module.GameMessage.GameMessageDidAddObject:
                    var figure = new Module.GMFigureType();
                    this.gameControlDidAddObjectWithType(figure[(messageInfo.value)]);
                    break;
                case Module.GameMessage.GameMessageNeedDisplay:
                    this.gameControlNeedDisplay();
                    break;
            }
        }
        this.isReadingMessages = false;
    };
    GameView.prototype.gameControlDidAddObjectWithType = function (figureType) {
    };
    GameView.prototype.gameControlNeedDisplay = function () {
        this.render.renderFigures();
    };
    GameView.prototype.checkHandCursor = function (coord) {
        var flag = false;
        this.gameControl.hover(coord);
        var messageInfo = new Module.MessageInfo();
        while (this.gameControl.popGameMessage(messageInfo)) {
            if (messageInfo.message == Module.GameMessage.GameMessageDidChangeCursor && messageInfo.value == 0) {
                flag = true;
            }
        }
        return flag;
    };
    GameView.prototype.remove = function () {
        this.render.remove();
    };
    return GameView;
}());
exports.GameView = GameView;



//////////////////
// WEBPACK FOOTER
// ./src/gameView.ts
// module id = 254
// module chunks = 0